import React, { useEffect, useState } from "react";
import "./App.css"; // Import the external CSS file
import axios from "axios";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useParams,
} from "react-router-dom";
import AI from "./ai";
function App() {
  return (
    <Router>
      <Routes>
        <Route index path="/" element={<InitComponent />} />

        <Route path="/*" element={<h2>Invalid Request</h2>} />
      </Routes>
    </Router>
  );
}

const InitComponent = () => {
  const [error, setError] = useState("");
  const searchParams = new URLSearchParams(window.location.search);
  const report_id = searchParams.get("r");

  const doc_id = searchParams.get("d");

  useEffect(() => {
    // Trigger the download as soon as the component mounts
    const downloadLabReport = async () => {
      try {
        const response = await axios.get(
          `https://reports.ideaclinics.com/api/download/report?id=${report_id}`,
          //`http://localhost:5000/api/download/report?id=${report_id}`,

          {
            responseType: "blob", // To handle file downloads
          }
        );
        console.log("response", response);

        if (!response || response.status != 200) {
          throw new Error(response.statusText);
        }

        // Get the filename from the Content-Disposition header
        const contentDisposition = response.headers["content-disposition"];
        console.log("Content-Disposition header:", contentDisposition); // Debugging log

        // Step 4: Extract the filename from the Content-Disposition header
        let filename = "default-filename.pdf"; // Default filename if none is provided

        if (contentDisposition && contentDisposition.includes("attachment")) {
          const matches = /filename="(.+)"/.exec(contentDisposition);
          if (matches && matches[1]) {
            filename = matches[1]; // Extracted filename
          }
        }
        console.log("filename", filename);

        // Create a Blob from the response data
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        // Create a temporary link to trigger the download
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();

        // Clean up the DOM by removing the link
        link.parentNode.removeChild(link);
      } catch (error) {
        setError(
          error.message || "An error occurred while downloading the PDF."
        );
      }
    };

    const downloadDocument = async () => {
      try {
        const response = await axios.get(
          `https://reports.ideaclinics.com/api/download/docs?id=${doc_id}`,
          // `http://localhost:5000/api/download/docs?id=${doc_id}`,

          {
            responseType: "blob", // To handle file downloads
          }
        );
        console.log("response", response);

        if (!response || response.status != 200) {
          throw new Error(response.statusText);
        }

        // Get the filename from the Content-Disposition header
        const contentDisposition = response.headers["content-disposition"];
        console.log("Content-Disposition header:", contentDisposition); // Debugging log

        // Step 4: Extract the filename from the Content-Disposition header
        let filename; // Default filename if none is provided

        if (contentDisposition && contentDisposition.includes("attachment")) {
          const matches = /filename="(.+)"/.exec(contentDisposition);
          if (matches && matches[1]) {
            filename = matches[1]; // Extracted filename
          }
        }
        console.log("filename", filename);

        // Create a Blob from the response data
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const url = window.URL.createObjectURL(blob);

        // Create a temporary link to trigger the download
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();

        // Clean up the DOM by removing the link
        link.parentNode.removeChild(link);
      } catch (error) {
        setError(
          error.message || "An error occurred while downloading the PDF."
        );
      }
    };

    if (report_id) {
      downloadLabReport(); // Trigger the download if the ID is present
    } else if (doc_id) {
      downloadDocument();
    }
  }, [report_id, doc_id]); // Dependency on params.id to trigger when the ID changes

  if (error)
    return (
      <h3
        style={{
          color: "red",
          textAlign: "center",
        }}
        dangerouslySetInnerHTML={{
          __html: error,
        }}
      />
    );

  return <h3 style={{ textAlign: "center" }}>Downloading PDF...</h3>;
};

export default App;
